<template>
  <router-view />
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'AuthenticateToken',
  async created() {
    this.startLoading(this.$options.name);
    await this.$store.dispatch(
      'session/init',
      {
        incognito: this.$route.query.incognito,
        name: this.$route.name,
        phoneNumberFromQuery: this.$route.query.phoneNumber,
      },
    );
    const query = Object.assign({}, this.$route.query);
    delete query.phoneNumber;
    this.$router.replace({ query });
    this.doneLoading(this.$options.name);
  },
  methods: {
    ...mapActions('loader', ['startLoading', 'doneLoading']),
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/AuthenticateToken.vue